<template>
<div>
    <TotemTag
        :name="$t('CourseListFilter.clear_all_filters')"
        v-if="isThereActiveFilters"
        @handleClick="removeAllTags"
        class="desktop-clear-filters"
        :clearAll="true"
    />
    <TotemToast ref="toast" />
</div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'DesktopClearFilters',
        methods: {
            removeAllTags () {
                this.$store.dispatch('Search/clearAllFilters')
                this.$refs.toast.show(this.$t('CourseListFilter.clear_search_notification'))
            }
        },
        computed: {
            ...mapGetters({
                filters: 'Search/filters',
                isThereActiveFilters: 'Search/isThereAnyActiveFilter'
            })
        }
    }
</script>
